import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import InputLabel from "@mui/material/InputLabel";
import { Field } from "react-final-form";
import "react-datepicker/dist/react-datepicker.css";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";

export default function UiDateRangePicker(props) {
     const [dateRange, setDateRange] = useState([null, null]);
     const [startDate, endDate] = dateRange;

     useEffect(() => {
          if (props.dateRange) {
               setDateRange(props.dateRange);
          }
     }, [props.dateRange]);

     const CustomInput = React.forwardRef((props, ref) => {
          return (
               <>
                    {props.rangeName ? 
                    <InputLabel>{props.rangeName}</InputLabel>:<InputLabel>Duration</InputLabel>}
                    <OutlinedInput
                         id="search"
                         type="text"
                         label="Duration"
                         fullWidth
                         {...props}
                         ref={ref}
                    />
               </>
          );
     });

     return (
          <>
               <Field
                    name={props.name}
                    render={({ input, meta }) => {
                         return (
                              <>
                                   <div className="sba-date-range-picker">
                                        <FormControl
                                             sx={{ mb: 2 }}
                                             variant="outlined"
                                             fullWidth
                                             error={meta.error}
                                        >
                                             <DatePicker
                                                  //   {...input}
                                                  selectsRange={true}
                                                  popperPlacement="top-end"
                                                  startDate={startDate}
                                                  endDate={endDate}
                                                  monthsShown={2}
                                                  className="red-border"
                                                  customInput={<CustomInput rangeName={props.rangeName}/>}
                                                  onChange={(update) => {
                                                       setDateRange(update);

                                                       if (
                                                            !update.includes(
                                                                 null,
                                                            )
                                                       ) {
                                                            input.onChange(
                                                                 update,
                                                            );
                                                       }
                                                  }}
                                                  isClearable={true}
                                             />

                                             {meta.error && (
                                                  <FormHelperText className="component-error-text">
                                                       {meta.error}
                                                  </FormHelperText>
                                             )}
                                        </FormControl>
                                   </div>
                              </>
                         );
                    }}
               />
          </>
     );
}
